export const EMAIL_BUILDER_EXPORT_FALLBACK_FILENAME = "email-campaign-draft.html";

export function normalizeEmailBuilderExportFilename(filename: string): string {
  const trimmed = filename.trim();
  const sanitized = trimmed
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/^\.+/, "")
    .replace(/\s+/g, "-");

  if (sanitized.length === 0) {
    return EMAIL_BUILDER_EXPORT_FALLBACK_FILENAME;
  }

  if (sanitized.toLowerCase().endsWith(".html")) {
    return sanitized;
  }

  return `${sanitized}.html`;
}

export type TEmailBuilderExportDownloadResult =
  | { ok: true; filename: string }
  | { ok: false; error: string };

export function downloadEmailBuilderExportHtml(
  html: string,
  filename: string,
): TEmailBuilderExportDownloadResult {
  if (html.length === 0) {
    return { ok: false, error: "Exported HTML was empty." };
  }

  const safeFilename = normalizeEmailBuilderExportFilename(filename);

  try {
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = safeFilename;
    link.click();
    URL.revokeObjectURL(url);
    return { ok: true, filename: safeFilename };
  } catch {
    return { ok: false, error: "Could not download email HTML." };
  }
}
